import { useStyles } from './style'

const MainHeaderButtonsWrapper = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>
}

export default MainHeaderButtonsWrapper
